import cgtConfig from "../cgt-config";

export default class UserCard   {

      constructor(obj){
        
        this.USRID=obj.USRID;
        this.USRName=obj.USRNAME;
        this.USREMail=obj.USREMAIL;
        this.USRPswd=obj.USRPSWD;
        this.USRRole=obj.USRROLE;
        this.USRAvatar=obj.USRAVATAR;
        this.USRPrevLog=obj.USRPREVLOG;
        this.USRLastLog=obj.USRLASTLOG;
        this.USRPassive=obj.USRPASSIVE;
        this.USROnCreateBranch=obj.USRCBRCH;
        this.USROnCreateTerminal=obj.USRCTERM;
        this.USROnCreateUser=obj.USRCUSER;
        this.USROnCreateTime=obj.USRCTIME;
        this.USROnUpdateBranch=obj.USRUBRCH;
        this.USROnUpdateTerminal=obj.USRUTERM;
        this.USROnUpdateUser=obj.USRUUSER;
        this.USROnUpdateTime=obj.USRUTIME;
    }

}